import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';

import Constants from '../Constants';
import { useAuth, has_permission } from '../AuthContext';
import '../App.css';

import wordmark from '../assets/menu-wordmark.png';
import dashboard from '../assets/dashboard-icon.jpg';

function SideMenu() {
	const { token, is_superadmin, user_permissions, subscription_features } = useAuth();
	const navigate = useNavigate();
	const show_personas = is_superadmin || has_permission(user_permissions, 'persona_editor');

	// The parts of the app a plan pays for. A subscription that is suspended for a refused payment
	// grants no features, so those links are taken away rather than left to fail on the far side of
	// a click. Account, Dashboard, Feedback and Help stay: the account page is where the reason is
	// explained, and a user must be able to reach it.
	const has_plan_features = is_superadmin || (subscription_features && subscription_features.length > 0);

	const [show_help, set_show_help] = useState(false);
	const [help_pages, set_help_pages] = useState([]);
	const [help_loading, set_help_loading] = useState(false);

	const handle_logout = () => {
		localStorage.removeItem('aicalltrainer-token');
		localStorage.removeItem(Constants.USER_EMAIL);
		localStorage.removeItem(Constants.USER_ID);
		navigate('/login');
	};

	const handle_help_open = () => {
		if(help_pages.length === 0) {
			set_help_loading(true);
			const headers = token ? { Authorization: 'Bearer ' + token } : {};
			axios.get(Constants.SERVER_URL + '/api/help/pages', { headers })
				.then(function(res) {
					set_help_pages(res.data.pages || []);
					set_help_loading(false);
				})
				.catch(function() {
					set_help_loading(false);
				});
		}
		set_show_help(true);
		navigate('/help/introduction');
	};

	const handle_help_close = () => {
		set_show_help(false);
	};

	const render_menu_link = (label, link) => {
		return (
			<li key={link}>
				<span className="sidebar-link-container">
					<Link className="sidebar-link" to={link}>{label}</Link>
				</span>
			</li>
		);
	};

	// {is_superadmin ? render_menu_link('Beta Test', '/admin/beta-test') : null}

	const render_normal_menu = () => {
		return (
			<React.Fragment>
				{render_menu_link('Dashboard', '/dashboard')}
				{has_plan_features ? render_menu_link('Calls', '/calls') : null}
				{has_plan_features ? render_menu_link('Sales Profiles', '/sales-profiles') : null}
				{show_personas ? render_menu_link('Prospect Personas', '/admin/personas') : null}
				{is_superadmin ? render_menu_link('Agents', '/agents') : null}
				{is_superadmin ? render_menu_link('Unit Economics', '/admin/unit-economics') : null}
				{is_superadmin ? render_menu_link('Cold Emailer', '/admin/cold-emailer') : null}
				{is_superadmin ? render_menu_link('Lead Discovery', '/leaddiscovery') : null}
				
				{render_menu_link('Account', '/account')}
				{render_menu_link('Feedback', '/feedbackform')}
				<li>
					<span className="sidebar-link-container">
						<button className="sidebar-link sidebar-link-btn" onClick={handle_help_open}>
							Help
						</button>
					</span>
				</li>
			</React.Fragment>
		);
	};

	const render_help_menu = () => {
		return (
			<React.Fragment>
				<li className="sidebar-help-heading">
					<span className="sidebar-help-title">Help</span>
				</li>
				{help_loading ? (
					<li className="sidebar-help-loading">Loading...</li>
				) : (
					help_pages.map(function(page) {
						return (
							<li key={page.id}>
								<span className="sidebar-link-container">
									<NavLink
										className={function({ isActive }) {
											return 'sidebar-link' + (isActive ? ' sidebar-link-active' : '');
										}}
										to={'/help/' + page.key}>
										{page.title}
									</NavLink>
								</span>
							</li>
						);
					})
				)}
				<li className="sidebar-help-close">
					<span className="sidebar-link-container">
						<button className="sidebar-link sidebar-link-btn sidebar-help-close-btn" onClick={handle_help_close}>
							Close
						</button>
					</span>
				</li>
			</React.Fragment>
		);
	};

	return (
		<div className="sidebar">
			<ul className="sidebar-menu">
				{show_help ? render_help_menu() : render_normal_menu()}
			</ul>
		</div>
	);
}

export default SideMenu;
